import Typo1 from './../images/works/Typo/Allahu-Akbar.jpg'
import Typo2 from './../images/works/Typo/Ar-Rahman.jpg'
import Typo3 from './../images/works/Typo/IMG.bmp'
import Typo4 from './../images/works/Typo/Noboborsho-Typo.jpg'

const Typo = [Typo1, Typo2, Typo3, Typo4]

export default Typo